import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './mirin-verify-privacy.component.html',
  styleUrls: ['./mirin-verify-privacy.component.scss']
})
export class MirinVerifyPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
